import { types } from './appparams.type';

export const updateUserInfo = (userInfo) => {
    return {
        type: types.UPDATE_USER_INFO,
        userInfo,
    }
}